import store, { actions } from "../../redux";
import { NewsFeedProps } from "../../redux/slices/newsfeed/NewsFeed";
import { EMPTY_NEWS_FEED_MESSAGE } from "../../utils";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";
import { setPostCommentsIfRepost } from "./posts";

const dispatch = store.dispatch;

const getNewsFeedPosts = (payload: NewsFeedProps.getNewsFeedPostsPayload) => {
  dispatch(actions.newsfeed.setGetNewsFeedPost_API_STATUS("progress"));
  API_INSTANCES.NEWSFEED.getNewsFeedPosts(payload)
    .then((response) => {
      if (response.data.message === EMPTY_NEWS_FEED_MESSAGE) {
        dispatch(actions.newsfeed.reset());
        return;
      }
      const data = response.data as NewsFeedProps.getNewsFeedPostsResponse;
      dispatch(actions.newsfeed.setNewsFeedPost(data));
      dispatch(actions.newsfeed.setGetNewsFeedPost_API_STATUS("success"));
      Object.values(data.processed_posts).forEach((post) => {
        if (!post) return;
        dispatch(
          actions.comments.setPostComment({
            post_id: post.ID,
            post_comment: post.post_comment ?? [],
            total_count: post.MainCommentCount,
          })
        );
        setPostCommentsIfRepost(post);
      });
    })
    .catch((error) => {
      dispatch(actions.newsfeed.setGetNewsFeedPost_API_STATUS("error"));
      handleError(error, "getNewsFeedPosts");
    });
};

export const NEWSFEED = { getNewsFeedPosts };
